import { render } from "./EmptyState.vue?vue&type=template&id=4d1162bc"
import script from "./EmptyState.vue?vue&type=script&lang=js"
export * from "./EmptyState.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__